import { createGlobalStyle } from "styled-components";

import Inter from "./fonts/Inter-Regular.woff2";

const GlobalFonts = createGlobalStyle`

@font-face {
  font-family: 'Inter';
  font-weight: 300;
  src: local(''),
       url('${Inter}') format('woff2'); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
}

`;

export default GlobalFonts;
